import React, { useEffect, useRef } from "react";
import l from "components/util/l";

// Files dropped here land on the chat-wide overlay, not on the zone: it is the target for
// clicking and pasting. It takes focus when it appears so a Ctrl+V works right away.
const ConversationDropZone = ({
  browseOption,
  isDisabled = false,
  onSelectOption,
}) => {

  const zoneRef = useRef(null);

  useEffect(() => {
    zoneRef.current.focus();
  }, []);

  return (
    <div id="chat-prompt-attachments"
      ref={zoneRef}
      tabIndex={0}
      role="button"
      className={`d-flex align-items-center ${isDisabled ? "is-disabled" : ""}`}
      onClick={() => onSelectOption(browseOption)}>

      <i className="fas fa-cloud-arrow-up mr-3" />
      <span>{l("Arrastra, pega o haz clic para adjuntar un archivo%CH044")}</span>

    </div>
  );

};

export default ConversationDropZone;
